import { Core, Decorative } from "@faire/design-tokens";
import { BuilderProductGridInlineBanner } from "@faire/retailer-visitor-shared/components/SignUpProductGridBanner/BuilderProductGridInlineBanner";
import {
  popSignUp,
  SignUpElement,
  SignUpType,
} from "@faire/retailer-visitor-shared/lib/popSignUp";
import {
  useAssignSettingBatch9LoggedOutPagesInlineBanner,
  useSettingBatch9LoggedOutPagesInlineBanner,
} from "@faire/retailer-visitor-shared/settings/useSettingBatch9LoggedOutPagesInlineBanner";
import { useSearchPageIsFromDiscoverURL } from "@faire/retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageIsFromDiscoverURL";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { ISignUpProductGridBanner } from "@faire/web-api--source/indigofair/data/ISignUpProductGridBanner";
import React from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";

export const SignUpProductGridBanner: React.FC<{
  info: ISignUpProductGridBanner;
}> = ({ info }) => {
  const assignSetting = useAssignSettingBatch9LoggedOutPagesInlineBanner();
  const shouldUseNewInlineBanner = useSettingBatch9LoggedOutPagesInlineBanner();
  const ref = useDoActionWhenVisible(() => {
    if (!isDiscoverPage) {
      assignSetting();
    }
  });

  const history = useHistory();
  const onSignUpClick = () => {
    popSignUp(history, SignUpType.GENERIC, () => {}, {
      element: SignUpElement.PRODUCT_GRID,
      sourceId: "logged_out_sign_up_product_grid_banner",
    });
  };

  const { strictLocalize } = useStrictLocalization();
  const buttonLabel = strictLocalize({
    defaultMessage: "Sign up for free",
    description: {
      text: "Text on button which appears in the product grid for logged-out users",
      img: "https://cdn.faire.com/fastly/7ceda48d7bfcd743b176432db970354eafb7d787f0c73a905cbff372d5ab3094.png",
    },
  });
  const isDiscoverPage = useSearchPageIsFromDiscoverURL();

  if (shouldUseNewInlineBanner || isDiscoverPage) {
    return (
      <BuilderProductGridInlineBanner
        onViewEvent={() => {
          if (!isDiscoverPage) {
            assignSetting();
          }
        }}
      />
    );
  }

  return (
    <StyledColumn align="center" justify="center" ref={ref}>
      <Typography align="center" variant="pageHeaderSerifRegular">
        {info.title}
      </Typography>
      <Spacer height="1x" />
      <Typography align="center" variant="paragraphSansRegular">
        {info.subtitle}
      </Typography>
      <Spacer height="2x" />
      <Button onClick={onSignUpClick} variant="primary">
        {buttonLabel}
      </Button>
      <Spacer height="3x" />
      <Typography align="center" variant="labelSansRegular">
        {info.bottom_label}
      </Typography>
    </StyledColumn>
  );
};

const StyledColumn = styled(Column)`
  height: 100%;
  border: 1px solid ${Core.border.muted};
  padding: ${getSpacing("6x", "3x")};

  border: none;
  background-color: ${Decorative.tint.neutral};
`;
